import { loadingSkeletonGrid } from 'components/DiscoverPage/utils';

const LoadingGrid: React.FC = () => {
  return (
    <div className="mx-auto grid w-full grid-cols-1 gap-ds-xl px-4 xs:grid-cols-1 sm:grid-cols-2 sm:px-8 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3">
      {loadingSkeletonGrid.map((Item, i) => (
        <Item key={i} />
      ))}
    </div>
  );
};

export default LoadingGrid;
